import axiosInstance from "../config/axiosInterceptor";

export async function getStockCards() {
  return await axiosInstance.get("/api/StockCards");
}

export async function getStockCardById(id) {
  return await axiosInstance.get(`/api/StockCards/${id}`);
}

export async function postStockCard(stockName, stockPrice, customerCode) {
  const payload = {
    idstockTable: 0,
    stockName: stockName,
    stockPrice: stockPrice,
    customerCode: customerCode,
  };

  return await axiosInstance.post("/api/StockCards", payload);
}

export async function putStockCard(id, stockName, stockPrice, customerCode) {
  const payload = {
    idstockTable: id,
    stockName: stockName,
    stockPrice: stockPrice,
    customerCode: customerCode,
  };

  return await axiosInstance.put("/api/StockCards", payload);
}

export async function checkStockUsageInSlots(stockId) {
  const slots = await axiosInstance.get("/api/Slots");

  const usedInSlots = slots.filter(
    (slot) => slot.stockTable_idStockTable === stockId
  );

  return {
    isUsed: usedInSlots.length > 0,
    slots: usedInSlots,
    count: usedInSlots.length,
  };
}

export async function deleteStockCard(id) {
  return await axiosInstance.delete(`/api/StockCards/${id}`);
}
